import * as datadogRum from 'lib/telemetry/datadogRum';

let hasLoaded = false;
let pendingUserId: string | null | undefined;

export function identify(userId: string): void {
    pendingUserId = userId;
    if (!hasLoaded) return;

    datadogRum.setUser({ id: userId });
}

export function clearUser(): void {
    pendingUserId = null;
    if (!hasLoaded) return;

    datadogRum.clearUser();
}

export function markLoaded(): void {
    hasLoaded = true;

    if (pendingUserId === undefined) return;

    if (pendingUserId === null) {
        datadogRum.clearUser();
        return;
    }

    datadogRum.setUser({ id: pendingUserId });
}
